import { render, staticRenderFns } from "./UpdateAcuContract.vue?vue&type=template&id=0a54b843"
import script from "./UpdateAcuContract.vue?vue&type=script&lang=js"
export * from "./UpdateAcuContract.vue?vue&type=script&lang=js"
import style0 from "./UpdateAcuContract.vue?vue&type=style&index=0&id=0a54b843&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports